
import Vue from 'vue'
import {
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VForm,
  VSpacer,
} from 'vuetify/lib'
import JcdcBtn from '@/components/jcdc/JcdcBtn.vue'

export default Vue.extend({
  name: 'JcdcModalCard',
  components: {
    JcdcBtn,
    VCard,
    VCardTitle,
    VCardActions,
    VSpacer,
    VCardText,
    VForm,
  },
  props: {
    title: {
      type: String,
      default: 'Card Title',
    },
    primaryBtn: {
      type: String,
      default: 'OK',
    },
    secondaryBtn: {
      type: String,
      default: 'Cancel',
    },
    color: {
      type: String,
      default: 'primary',
    },
    hideDefaultActions: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: false,
    }
  },
  computed: {
    borderStyle(): string {
      return `border: 1px solid var(--v-${this.color}-base); border-top: 8px solid var(--v-${this.color}-base);`
    },
  },
  methods: {
    primaryBtnClick() {
      ;(this.$refs.form as Vue & { validate: () => boolean }).validate()
      if (this.valid) {
        this.$emit('primary-click')
      }
    },
    secondaryBtnClick() {
      this.$emit('secondary-click')
    },
  },
})
